import React, { useEffect, useState } from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { useHistory, useLocation } from 'react-router-dom'
import HomeHeader from 'components/HomePageHeader'
import Footer from 'components/Footer'
import { ErrorBox } from 'components/ErrorBox/ErrorBox'
import api from 'utils/api'
import { API_ROOT } from '../constants'
import { decideConsent, getConsent } from 'services/oauth'
import styles from './OAuthAuthorize.module.css'

// What the Tiiny Host connector's tools can do with the account
const ABILITIES = ['See your sites', 'Publish new sites and update them', 'Delete your sites']

const OAuthAuthorize = () => {
  const history = useHistory()
  const { search } = useLocation()
  const [client, setClient] = useState()
  const [email, setEmail] = useState()
  const [failed, setFailed] = useState(false)
  const [deciding, setDeciding] = useState(false)

  // Every way of signing in ends at redirect-url, which brings the person back to this request
  const signIn = () => {
    localStorage.removeItem('token')
    localStorage.setItem('redirect-url', window.location.href)
    history.replace('/login')
  }

  // The server answers 403 to a session it no longer accepts; any other failure stays on screen, so it can't loop via /login
  const signInOrFail = (err) => (err.response?.status === 403 ? signIn() : setFailed(true))

  useEffect(() => {
    if (!localStorage.getItem('token')) {
      signIn()
      return
    }
    api
      .post(`${API_ROOT}/v3/account/profile`)
      .then((res) => setEmail(res.data.userProfile.email))
      .catch(signInOrFail)
    getConsent(search)
      .then((res) => setClient(res.data.client.name))
      .catch(() => setFailed(true))
  }, [])

  const decide = (approve) => {
    setDeciding(true)
    decideConsent(search, approve)
      .then((res) => window.location.replace(res.data.redirectUrl))
      .catch(signInOrFail)
  }

  let body = <Spinner animation="border" />
  if (failed) {
    body = <ErrorBox message="We couldn't complete this request.<br />Go back and try connecting again." hideButton />
  } else if (client && email) {
    body = (
      <div className={styles.card}>
        <h1 className="bold font-26">Allow {client} to access your Tiiny Host account?</h1>
        <p className="op-6 mb-4">
          Signed in as <b>{email}</b>.{' '}
          <span className="link" onClick={signIn}>
            Use another account
          </span>
        </p>
        <p className="bold mb-2">{client} will be able to:</p>
        <ul className="mb-4">
          {ABILITIES.map((ability) => (
            <li key={ability}>{ability}</li>
          ))}
        </ul>
        <div className={styles.actions}>
          <Button variant="secondary" disabled={deciding} onClick={() => decide(false)}>
            Deny
          </Button>
          <Button disabled={deciding} onClick={() => decide(true)}>
            Allow
          </Button>
        </div>
      </div>
    )
  }

  return (
    <div className="body-bg full-height">
      <HomeHeader logoOnly />
      <div className={styles.page}>{body}</div>
      <Footer simplified />
    </div>
  )
}

export default OAuthAuthorize
